import { observer } from 'mobx-react-lite';

import { AppPage } from 'app/common/app-page/features/app-page/app-page';
import {
  NotificationsProvider,
  useNotifyFactory,
} from 'app/common/notifications/features/notifications';
import { PageContent } from 'app/ui';

import { AddRoleFeature } from '../features/roles/add-role';

export const AddRolePage = observer(() => {
  const pageNotify = useNotifyFactory();

  return (
    <NotificationsProvider value={pageNotify}>
      <AppPage perm="PERM_USER_ROLE_CREATE">
        <PageContent>
          <AddRoleFeature />
        </PageContent>
      </AppPage>
    </NotificationsProvider>
  );
});
